<template>
  <div class="approvedDialog">
    <el-dialog :close-on-click-modal="false" :visible.sync="_visible" title="审核通过信息提交" width="620px" @close="closeDialog">
      <el-form label-position="right" label-width="100px">
        <div class="asterisk">
          <el-form-item label="短信模板" prop="templateContent">
            <div id="editableDiv" class="content-box" :contenteditable="true">
              <span v-for="(item,index) in formatList" ref="container" :key="index" :title="index">
                <b v-if="item.type === 'text'" class="spanStyle">{{ item.value }}</b>
                <label v-else :class="{'inputStyle':item.colorStatus==true}">{{ item.value }}</label>
                <!-- <input
                        v-if="item.type === 'input'"
                        :class="{'inputStyle':item.colorStatus==true}"
                        type="text"
                        maxlength="5"
                        v-model="item.value"
                        :style="{ width: item.width  + 'px' }"
                        @blur="validateInput($event.target.value,index,item.inputIndex)"
                        @input="updateInputWidth($event.target.value,index,item.inputIndex)"
                        /> -->
              </span>
            </div>
            <div class="tips-box">
              <span class="tips">提示：{}内的文字表示为变量名称,只能输入5个中文字符</span>
              <el-button type="primary" @click="variableRetrieval">
                检索变量
              </el-button>
            </div>
          </el-form-item>
          <div class="flex">
            <div v-for="(item, index) in newArray" :key="index">
              <el-form-item :label="item.key">
                <el-input v-model="item.values" class="handle-form-input" maxlength="35" />
              </el-form-item>
            </div>
          </div>
        </div>
        <el-form-item>
          <div class="tips">
            请输入变量参数，首字母大写，支持字母、数字、下划线，限制35字。
          </div>
        </el-form-item>
        <div class="title">
          参考短信内容
        </div>
        <el-form-item label="内容1">
          <span class="content-box">
            <span v-for="(item,index) in formatContext1" :key="index">
              <span v-if="item.type === 'text'" class="spanStyle">{{ item.value }}</span>
              <label v-if="item.type === 'input'" :style="{ width: item.width + 'px' }">{{ item.value.replace(/[{}]/g, '') }}</label>
            </span>
          </span>
        </el-form-item>
        <el-form-item label="内容2">
          <span class="content-box">
            <span v-for="(item,index) in formatContext2" :key="index">
              <span v-if="item.type === 'text'" class="spanStyle">{{ item.value }}</span>
              <label v-if="item.type === 'input'" :style="{ width: item.width + 'px' }">{{ item.value.replace(/[{}]/g, '') }}</label>
            </span>
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeDialog">
          取消
        </el-button>
        <el-button type="primary" size="medium" :disabled="ajaxLoading" @click="submit">
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getSmsTemplatesInfo, approved, reApplyReview } from '@/api/messageCenter/index.js';
import pinyin from 'js-pinyin';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    templateId: {
      type: String,
      default: '',
      required: true
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      submitData: {
        templateContent: '',
        templateId: '',
        variable: [],
        variableSpell: {}
      },
      viewData: {},
      newArray: [],
      minWidth: 10, // 设置最小宽度
      maxWidth: 100, // 设置最大宽度
      formatList: [],
      ajaxLoading: true,
      formatContext1: [],
      formatContext2: [],
      isRetrieval: false
    };
  },
  computed: {
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  created() {
    this.getTemplatesInfo();
  },
  mounted() {
  },
  methods: {
    // 将文本格式化
    formatText(text) {
      if (!text) {
        return;
      }
      const regex = /\{([^{}]+)\}/g;
      const pattern = /^[\u4e00-\u9fa5]+$/;
      const matches = text.match(regex);
      const result = [];
      let lastIndex = 0;
      const submitStatus = [];
      // const inputIndex = -1;
      if (matches) {
        for (const match of matches) {
          const index = text.indexOf(match, lastIndex);
          const matchValue = match.replace('{', '').replace('}', '');
          if (index > lastIndex) {
            result.push({
              type: 'text',
              value: text.substring(lastIndex, index)
            });
          }
          result.push({
            type: 'input',
            value: match,
            colorStatus: this.isRetrieval ? matchValue.length > 5 || matchValue.includes('变量') : ''
            // width: ''
            // this.inputWidth(matchValue)
            // inputIndex: inputIndex += 1 // 这个字段是为了在提示下面的变量使用
          });
          lastIndex = index + match.length;
          if (this.isRetrieval === true) {
            if (matchValue && matchValue.length <= 5 && pattern.test(matchValue)) {
              pinyin.setOptions({ checkPolyphone: false, charCase: 1 }); // 设置选项
              const pinyinText = pinyin.getFullChars(matchValue);
              this.newArray.push({ key: matchValue, values: pinyinText.replace(/^\w/, (c) => c.toUpperCase()) });
              matchValue.includes('变量') === true ? submitStatus.push('true') : submitStatus.push('false');
            } else {
              submitStatus.push('true');
              this.$message.error('变量名称只能输入中文/不能超出5个字');
            }
          }
        }
      }
      if (lastIndex < text.length) {
        result.push({
          type: 'text',
          value: text.substring(lastIndex)
        });
      }
      this.ajaxLoading = submitStatus.includes('true') === true;
      return result;
    },
    // 变量检索
    variableRetrieval() {
      this.formatList = [];
      this.isRetrieval = true;
      const divElement = document.getElementById('editableDiv');
      const editedValue2 = divElement.innerText;
      this.$nextTick(() => {
        this.newArray = [];
        this.formatList = this.formatText(editedValue2);
      });
    },
    // inputWidth(value) {
    //   const textLength = value.length;
    //   const width = Math.max(this.minWidth, Math.min(this.maxWidth, textLength * 16)); // 根据文字长度计算宽度，每个字符占据10像素的宽度
    //   return width;
    // },
    // 验证是否输入了中文字符
    // validateInput(value, index, inputIndex) {
    //   if (!value) {
    //     this.ajaxLoading = true;
    //     this.$message.error('不能为空');
    //     return true;
    //   }
    //   const pattern = /^[\u4e00-\u9fa5]+$/;
    //   if (!pattern.test(value)) {
    //     this.ajaxLoading = true;
    //     this.$message.error('请输入中文字符');
    //     this.setFormatList(value, index, inputIndex, true);
    //     return true;
    //   }
    //   this.ajaxLoading = false;
    //   return false;
    // },
    // 根据字符输入个数设置动态宽度
    // updateInputWidth(value, index, inputIndex) {
    //   console.log(value);
    //   const regex = /{}/;
    //   if (regex.test(value)) {
    //     pinyin.setOptions({ checkPolyphone: false, charCase: 1 }); // 设置选项
    //     const pinyinText = pinyin.getFullChars(value);
    //     this.$set(this.newArray, inputIndex, { key: value, values: pinyinText.replace(/^\w/, (c) => c.toUpperCase()) });
    //   }
    //   this.setFormatList(value, index, inputIndex);
    // },
    // setFormatList(value, index, inputIndex, colorStatus) {
    //   const newObj = this.formatList[index];
    //   const width = this.inputWidth(value);
    //   this.$set(this.formatList, index, { type: newObj.type, value: value, width: width, inputIndex: inputIndex, colorStatus: colorStatus || false });
    // },
    // 关闭弹框
    closeDialog() {
      this._visible = false;
      this.submitData = {
        templateContent: '',
        templateId: '',
        variable: [],
        variableSpell: {}
      };
    },
    // 审核通过提交和重新申请审核提交
    submit() {
      this.submitData.templateContent = '';
      this.submitData.templateContent = this.formatList.map((item, index) => {
        return item.value;
      }).join('');
      const pattern = new RegExp(/^[A-Z][_A-z0-9]*$/);
      const regex = /[\u4e00-\u9fa5]/g;
      for (let i = 0; i < this.newArray.length; i++) {
        const matches = this.newArray[i].key.replace(/[{}]/g, '');
        if (this.newArray[i].key.includes('变量') === true) {
          this.$message.error('有默认变量名，请修改！');
          return;
        }
        if (matches && matches.length > 5 && !regex.test(matches)) {
          this.$message.error('不能超过5个中文字符');
          return;
        }
        if (!pattern.test(this.newArray[i].values)) {
          this.$message.error('请按规则输入参数');
          return;
        }
        this.submitData.variable.push(this.newArray[i].key);
      }
      const keys = new Set(this.newArray.map(item => item.key));
      if (keys.size !== this.newArray.length) {
        this.$message.error('当前提交变量有重复内容');
        return;
      }
      const op = {
        templateContent: this.submitData.templateContent,
        templateId: this.templateId,
        variable: this.submitData.variable,
        variableSpell: Object.fromEntries(this.newArray.map(item => [item.key, item.values]))
      };
      if (this.type === 'approved') {
        this.approved(op);
      } else {
        this.renew(op);
      }
    },
    // 审核通过
    approved(op) {
      approved(op).then(res => {
        this.$notify.success({ title: 'Success', message: '操作成功', showClose: false, duration: 2000 });
        this.closeDialog();
        this.$emit('refreshList');
      }).catch(() => {
        this.submitData.templateContent = '';
        this.submitData.variable = [];
      });
    },
    // 重新申请审核
    renew(op) {
      reApplyReview(op).then(res => {
        this.$notify.success({ title: 'Success', message: '操作成功', showClose: false, duration: 2000 });
        this.closeDialog();
        this.$emit('refreshList');
      }).catch(() => {
        this.submitData.templateContent = '';
        this.submitData.variable = [];
      });
    },
    // 获取短信模板信息
    getTemplatesInfo() {
      getSmsTemplatesInfo(this.templateId).then(res => {
        this.viewData = res.data;
        if (this.viewData) {
          this.submitData.templateContent = res.data.template;
          this.formatList = this.formatText(this.viewData.template);
          this.formatContext1 = this.formatText(this.viewData.contentOneDispose);
          this.formatContext2 = this.formatText(this.viewData.contentTwoDispose);
          if (res.data.variableSpell) {
            for (const key in res.data.variableSpell) {
              this.newArray.push({ key: key, values: res.data.variableSpell[key] });
            }
          } else {
            for (let i = 0; i < this.viewData.variable.length; i++) {
              this.newArray.push({ key: this.viewData.variable[i], values: '' });
            }
          }
        }
      });
    }
  }
};
</script>
<style scoped>
  input{
        background:none;
        outline:none;
        border:none;
      }
</style>
<style lang="scss" scoped>
.approvedDialog{
  .tips{
    color: #FF0000;
  }
  .title{
    font-size: 18px;
    font-weight: 400;
    color: #3D3D3D;
    margin-bottom: 20px;
  }
  .asterisk{
    /deep/.el-form-item__label:before {
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
    }
  }
  .content-box{
    display: block;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    padding: 5px 15px;
    min-height: 80px;
    line-height: 27px;
    .inputStyle{
      color: #FF0000;
    }
    .spanStyle{
      color: #C0C4CC;
    }
  }
  .tips-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }
}
</style>
